<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router';
import { useNavigatorStore } from '@/store/navigator';
const route = useRoute()
const navigatorStore = useNavigatorStore()
</script>

<template>
  <div class="row content-title-wrap">
    <div class="col-lg-6">
      <div class="content-title">{{ route.meta.title }}</div>
    </div>
    <div v-if="!(navigatorStore.isMobile && route.path.includes('rd'))" class="col-lg-6">
      <div aria-label="breadcrumb float-end">
        <ol class="breadcrumb">
          <li v-for="item in route.meta.IADepth" class="breadcrumb-item" :class="{active: route.meta.IADepth.at(-1) === item}" :aria-current="route.meta.IADepth.at(-1) === item ? 'page' : ''">{{ item }}</li>
        </ol>
      </div>
    </div>
  </div>
</template>